
















import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import UserHistoryList from '@/components/history/UserHistoryList.vue'
import HistoryEvent from '@/dto/history/HistoryEvent'
import Paginator from '@/dto/history/Paginator'
import HistoryEventsService from '@/services/HistoryEventsService'
import { NotifyHelper } from 'vue-kit'

@Component({
  components: { UserHistoryList },
})
export default class UserHistory extends Vue {
  history: HistoryEvent[] = []
  paginator: Paginator | null = null
  isPending: boolean = false
  offset: number = 0

  created() {
    this.isPending = true

    HistoryEventsService.loadHistoryEvents()
      .then(({ history, paginator }) => {
        this.history = history
        this.paginator = paginator
      })
      .catch(() => NotifyHelper.error('Ошибка сервера при получении истории'))
      .finally(() => {
        this.isPending = false
        this.offset = 100
      })
  }

  loadHistory(index: number, done: Function) {
    const paginator = this.paginator as Paginator

    if (paginator === null) {
      return done()
    }

    if (paginator.isLast) {
      this.offset = 0
      return done()
    }

    HistoryEventsService.loadHistoryEvents(paginator.current + 1)
      .then(({ history, paginator }) => {
        this.history = [...this.history, ...history]
        this.paginator = paginator
      })
      .catch(() => NotifyHelper.error('Ошибка сервера при получении истории'))
      .finally(() => done())
  }
}
